const DAILY_MOBILE_LAYOUT_KEY = 'dailyMobileSideBySide';

function canUseLocalStorage() {
  try {
    return typeof window !== 'undefined' && typeof window.localStorage !== 'undefined';
  } catch {
    return false;
  }
}

/**
 * @returns {boolean|null} boolean when saved, otherwise null
 */
export function loadDailyMobileSideBySidePreference() {
  if (!canUseLocalStorage()) return null;

  try {
    const raw = window.localStorage.getItem(DAILY_MOBILE_LAYOUT_KEY);
    if (raw === null) return null;
    if (raw === 'true') return true;
    if (raw === 'false') return false;
    return null;
  } catch {
    return null;
  }
}

/**
 * @param {boolean} value
 */
export function saveDailyMobileSideBySidePreference(value) {
  if (!canUseLocalStorage()) return;

  try {
    window.localStorage.setItem(DAILY_MOBILE_LAYOUT_KEY, String(Boolean(value)));
  } catch {
    // ignore write failures (private mode, quota, etc.)
  }
}
